import React, { useEffect, useRef } from "react";
import $ from "jquery";
import ReactDOMServer from "react-dom/server";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";

const ReactDataTableWrapper = ({
  columns = [],
  data = [],
  options = {},
  onRowClick,
  onCellClick,
}) => {
  const tableRef = useRef(null);
  const dt = useRef(null);

  useEffect(() => {
    if (!tableRef.current) return;

    dt.current = $(tableRef.current).DataTable({
      paging: true,
      searching: false,
      lengthChange: false,
      pageLength: 10,
      destroy: true,
      info: false,
      // scrollY: "65vh",
      scrollX: true,
      scrollCollapse: true,
      data: [],
      // dom: 't<"pagination-container"p>',
      pagingType: "simple_numbers",
      columns: columns.map((col, columnIndex) => ({
        title: col.title,
        data: null,
        render: (row) => {
          if (col.render) {
            const content = col.render(row);

            if (typeof content === "string") {
              return content;
            }

            return ReactDOMServer.renderToString(content);
          }

          return row[col.data] ?? "";
        },
        createdCell: (td, cellData, rowData) => {
          if (onCellClick) {
            $(td).on("click", (e) => {
              e.stopPropagation();
              onCellClick(rowData, columnIndex);
            });
          }
        },
      })),

      columnDefs: [
        {
          targets: "_all",
          defaultContent: "",
        },
      ],
      createdRow: (row, rowData, rowIdx) => {
        if (onRowClick) {
          $(row).on("click", () => {
            const rowsData = dt.current.row(row).data();
            onRowClick(rowsData, rowData, rowIdx);
          });
        }
      },
      ...options,
    });

    return () => {
      if (dt.current) {
        dt.current.destroy();
      }
    };
  }, []);

  useEffect(() => {
    if (!dt.current) return;

    dt.current.clear();
    dt.current.rows.add(data);
    dt.current.draw();
  }, [data]);

  return (
    <table
      ref={tableRef}
      className="table table-bordered task-management"
      style={{ width: "100%" }}
    />
  );
};

export default ReactDataTableWrapper;
